import { AvatarLoadingSkeleton } from '@helpcenter/loading/src/styled';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ForgeModalContextProvider = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "forge-modal-context-provider" */ './modal-context-provider'),
	),
	LoadingSkeleton: AvatarLoadingSkeleton,
});
